import { api } from '@/lib/api'
import { API_PATHS } from '@/constants/api-paths'
import type { ApiResponse } from '@/types'

/** One weekday of the organisation's Opening Hours, in its local time ("HH:MM"). */
export type OfficeDay = {
  /** 1 = Monday … 7 = Sunday */
  day: number
  label: string
  open: boolean
  start: string | null
  end: string | null
  configured: boolean
}

export type OfficeHours = {
  /** "default" until Opening Hours are set up for the organisation. */
  source: 'opening_hours' | 'default'
  days: OfficeDay[]
  today: OfficeDay
  time_zone?: string
  can_edit?: boolean
  /** Where the Opening Hours are edited (Organisation Settings → Opening Hours). */
  settings?: { instance_id: string; primary_node_id: number | string | null }
}

const DEFAULT_DAYS: OfficeDay[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((label, index) => ({
  day: index + 1,
  label,
  open: index < 5,
  start: index < 5 ? '10:00' : null,
  end: index < 5 ? '17:00' : null,
  configured: false,
}))

export const DEFAULT_OFFICE_HOURS: OfficeHours = {
  source: 'default',
  days: DEFAULT_DAYS,
  today: DEFAULT_DAYS[(new Date().getDay() + 6) % 7],
}

export const officeHoursApi = {
  get: async (): Promise<OfficeHours> => {
    const { data } = await api.get<ApiResponse<OfficeHours>>(API_PATHS.officeHours.get)
    return { ...DEFAULT_OFFICE_HOURS, ...data.data }
  },
}
